import { QuestionResponse } from '../interfaces/EmailData'
import questions from './questions.json'

const calculateAnswers = (answers: any) => {
	let sumTotal = 0
	const merged = questions.reduce((acc: any, questions) => {
		const answersForCategory = answers[questions.name]
		let categorySum = 0
		// check if name exists as a key in answers
		if (!answersForCategory) return acc

		acc.push({
			_id: questions._id,
			name: questions.name,
			questions: questions.questions.map(q => {
				sumTotal += answersForCategory.questions[q._id] ?? 0
				categorySum += answersForCategory.questions[q._id] ?? 0
				const answer = answersForCategory.questions[q._id] ?? 0
				let answerText
				switch (answer) {
					case 1:
						answerText = 'Discordo'
						break
					case 2:
						answerText = 'Discordo Parcialmente'
						break
					case 3:
						answerText = 'Talvez'
						break
					case 4:
						answerText = 'Concordo Parcialmente'
						break
					case 5:
						answerText = 'Concordo'
						break
				}
				return {
					_id: q._id,
					question: q.question,
					answer,
					answerText,
				} as QuestionResponse
			}),
			categorySum,
		})
		return acc
	}, [])
	return {
		answers: [...merged],
		totalPoints: sumTotal,
	}
}
export default calculateAnswers
